import request from '@/utils/request'


export const testList = (data) => request.post('/apis/api/test/index', data);  //检测记录

export const otherTestList = (data) => request.post('/apis/api/test/indexs', data);  //他人检测记录

export const shareImg = (data) => request.post('/apis/api/water/index', data);  //分享海报

export const indexList = (data) => request.post('/apis/api/test/home', data);  //主页检测记录